import { defineComponent as _defineComponent } from 'vue'
import { getSwipe } from "@/api/php/home";
import { ref, onMounted, Ref } from "vue";
import { RoomModel } from "@/model/swiper";
import EventBus from "@/uitls/EventBus";
import BannerSwiper from "@/components/home/BannerSwiper.vue";


const __default__ = {
  name: "HomeSwiper",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  height: {
    type: Number,
    default: 0,
  },
},
  emits: ["getalldata"],
  setup(__props, { expose, emit }) {

const props = __props

const app_name = process.env.VUE_APP_NAME;
const swipeSpace = app_name == 'vi' ? '0px' : '10px';



const ynSwipeWidth = typeof document == 'undefined' ? 0 : document.documentElement.clientWidth - 20;
const swipeWidth = app_name == 'vi' ? undefined : ynSwipeWidth;
const swipeHeight = props.height > 0 ? props.height : (app_name == 'vi' ? 400 : Math.round(ynSwipeWidth * 0.45));
const boxPadding = `0px ${swipeSpace} 5px ${swipeSpace}`;

onMounted(() => {
  getData();
});
function getalldata() {
  getData();
}

expose({ getalldata });

let stlogin = ref({
  frequency: 0,
  title: "Swiper",
});
const data: Ref<Array<RoomModel>> = ref([]);
const getData = async () => {
  const res: any = await getSwipe();

  if (res.code == 200) {
    data.value = res.data;
    emit("getalldata", stlogin);
    swiperChange(0)
  }
};
const bgColor = ref("#999")
const swiperChange = (index, item = data.value[index]) => {
  if (!data.value || data.value.length == 0 || !item) {
    return
  }
  bgColor.value = item.color
  EventBus.emit("swiperColor", {
    "tabBgColor": item.color,
    "titleActiveColor": '#FFF',
    'titleInactiveColor': '#F6F6F6',
    "index": index
  })
}

const __returned__ = { app_name, swipeSpace, props, emit, ynSwipeWidth, swipeWidth, swipeHeight, boxPadding, getalldata, stlogin, data, getData, bgColor, swiperChange, BannerSwiper }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})